// @generated by protobuf-ts 2.9.0 with parameter generate_dependencies,force_optimize_code_size,long_type_string,ts_nocheck
// @generated from protobuf file "codesandbox/v1/codesandbox.proto" (package "codesandbox.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
//
// Internal RPCs for the Control tab's code sandbox.
//
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { CodeSandboxService } from "./codesandbox";
import type { RecordRunResponse } from "./codesandbox";
import type { RecordRunRequest } from "./codesandbox";
import type { CheckHealthResponse } from "./codesandbox";
import type { CheckHealthRequest } from "./codesandbox";
import type { StopProgramResponse } from "./codesandbox";
import type { StopProgramRequest } from "./codesandbox";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { RunProgramResponse } from "./codesandbox";
import type { RunProgramRequest } from "./codesandbox";
import type { ServerStreamingCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * CodeSandboxService runs a single-file program against one machine part in an
 * ephemeral sandbox and streams its output back.
 *
 * A sandbox's lifetime is scoped to one RunProgram call, and no sandbox
 * identifier ever reaches the caller — the browser never talks to a sandbox.
 *
 * @generated from protobuf service codesandbox.v1.CodeSandboxService
 */
export interface ICodeSandboxServiceClient {
    /**
     * Runs source in a fresh sandbox, streaming stdout and stderr until it exits.
     * Requires control access to the part the run is bound to.
     *
     * @generated from protobuf rpc: RunProgram(codesandbox.v1.RunProgramRequest) returns (stream codesandbox.v1.RunProgramResponse);
     */
    runProgram(input: RunProgramRequest, options?: RpcOptions): ServerStreamingCall<RunProgramRequest, RunProgramResponse>;
    /**
     * Terminates a run started by the caller. Someone else's run is reported as
     * absent rather than denied, so run IDs cannot be probed for existence.
     *
     * @generated from protobuf rpc: StopProgram(codesandbox.v1.StopProgramRequest) returns (codesandbox.v1.StopProgramResponse);
     */
    stopProgram(input: StopProgramRequest, options?: RpcOptions): UnaryCall<StopProgramRequest, StopProgramResponse>;
    /**
     * Reports whether a program could run right now: the provider is configured,
     * reachable, and accepts our credentials.
     *
     * Unauthenticated in the sense that it names no part and reveals nothing
     * about one — it answers about this deployment, not about a machine.
     *
     * A deployment with no provider configured does not register this service at
     * all, so the call is Unimplemented rather than false. Both mean the same
     * thing to a caller: no server-side program can run here.
     *
     * @generated from protobuf rpc: CheckHealth(codesandbox.v1.CheckHealthRequest) returns (codesandbox.v1.CheckHealthResponse);
     */
    checkHealth(input: CheckHealthRequest, options?: RpcOptions): UnaryCall<CheckHealthRequest, CheckHealthResponse>;
    /**
     * Records that the user asked for a program to run, for usage metrics only.
     *
     * Separate from RunProgram because TypeScript never calls RunProgram: it
     * executes in a Web Worker in the user's own browser and never reaches this
     * service. Counting inside RunProgram would report every language but the
     * one most likely to be a user's first.
     *
     * Requires the same control access RunProgram does, so a caller cannot
     * attribute runs to a machine they cannot use. Nothing observable depends on
     * the response: the caller records and moves on, whatever this returns.
     *
     * @generated from protobuf rpc: RecordRun(codesandbox.v1.RecordRunRequest) returns (codesandbox.v1.RecordRunResponse);
     */
    recordRun(input: RecordRunRequest, options?: RpcOptions): UnaryCall<RecordRunRequest, RecordRunResponse>;
}
/**
 * CodeSandboxService runs a single-file program against one machine part in an
 * ephemeral sandbox and streams its output back.
 *
 * A sandbox's lifetime is scoped to one RunProgram call, and no sandbox
 * identifier ever reaches the caller — the browser never talks to a sandbox.
 *
 * @generated from protobuf service codesandbox.v1.CodeSandboxService
 */
export class CodeSandboxServiceClient implements ICodeSandboxServiceClient, ServiceInfo {
    typeName = CodeSandboxService.typeName;
    methods = CodeSandboxService.methods;
    options = CodeSandboxService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * Runs source in a fresh sandbox, streaming stdout and stderr until it exits.
     * Requires control access to the part the run is bound to.
     *
     * @generated from protobuf rpc: RunProgram(codesandbox.v1.RunProgramRequest) returns (stream codesandbox.v1.RunProgramResponse);
     */
    runProgram(input: RunProgramRequest, options?: RpcOptions): ServerStreamingCall<RunProgramRequest, RunProgramResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<RunProgramRequest, RunProgramResponse>("serverStreaming", this._transport, method, opt, input);
    }
    /**
     * Terminates a run started by the caller. Someone else's run is reported as
     * absent rather than denied, so run IDs cannot be probed for existence.
     *
     * @generated from protobuf rpc: StopProgram(codesandbox.v1.StopProgramRequest) returns (codesandbox.v1.StopProgramResponse);
     */
    stopProgram(input: StopProgramRequest, options?: RpcOptions): UnaryCall<StopProgramRequest, StopProgramResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<StopProgramRequest, StopProgramResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Reports whether a program could run right now: the provider is configured,
     * reachable, and accepts our credentials.
     *
     * Unauthenticated in the sense that it names no part and reveals nothing
     * about one — it answers about this deployment, not about a machine.
     *
     * A deployment with no provider configured does not register this service at
     * all, so the call is Unimplemented rather than false. Both mean the same
     * thing to a caller: no server-side program can run here.
     *
     * @generated from protobuf rpc: CheckHealth(codesandbox.v1.CheckHealthRequest) returns (codesandbox.v1.CheckHealthResponse);
     */
    checkHealth(input: CheckHealthRequest, options?: RpcOptions): UnaryCall<CheckHealthRequest, CheckHealthResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<CheckHealthRequest, CheckHealthResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Records that the user asked for a program to run, for usage metrics only.
     *
     * Separate from RunProgram because TypeScript never calls RunProgram: it
     * executes in a Web Worker in the user's own browser and never reaches this
     * service. Counting inside RunProgram would report every language but the
     * one most likely to be a user's first.
     *
     * Requires the same control access RunProgram does, so a caller cannot
     * attribute runs to a machine they cannot use. Nothing observable depends on
     * the response: the caller records and moves on, whatever this returns.
     *
     * @generated from protobuf rpc: RecordRun(codesandbox.v1.RecordRunRequest) returns (codesandbox.v1.RecordRunResponse);
     */
    recordRun(input: RecordRunRequest, options?: RpcOptions): UnaryCall<RecordRunRequest, RecordRunResponse> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<RecordRunRequest, RecordRunResponse>("unary", this._transport, method, opt, input);
    }
}
